import { observable, action, computed } from 'mobx'

class DropdownStore {

  @observable showSearchDropdown = false
  @observable showProfileDropdown = false
  @computed get showDropdown() {
    return this.showSearchDropdown || this.showProfileDropdown
  }

  //if search is shown, it should disapper. Else profile should disappear and search shoul appear
  @action.bound toggleSearchDropdown() {
    if(this.showSearchDropdown) {
      this.showSearchDropdown = false
    } else {
      this.showSearchDropdown = true
      this.showProfileDropdown = false
    }
  }

  @action.bound closeDropdown() {
    this.showSearchDropdown = false
    this.showProfileDropdown = false
  }

  @action.bound openProfileDropdown() {
    this.showSearchDropdown = false
    this.showProfileDropdown = true
  }

  @action.bound openSearchDropdown() {
    this.showSearchDropdown = true
    this.showProfileDropdown = false
  }

  @action.bound toggleProfileDropdown() {
    if(this.showProfileDropdown) {
      this.showProfileDropdown = false
    } else {
      this.showProfileDropdown = true
      this.showSearchDropdown = false
    }
  }
}

export default new DropdownStore()



// WEBPACK FOOTER //
// ./src/stores/dropdownStore.js